import { render } from "./DocPreview.vue?vue&type=template&id=c01b85ea&ts=true"
import script from "./DocPreview.vue?vue&type=script&lang=ts"
export * from "./DocPreview.vue?vue&type=script&lang=ts"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__